var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{},[_c('top-navbar'),_c('dashboard-content',{on:{"click":_vm.toggleSidebar}}),_c('content-footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }